import React from 'react';
import { Steps } from 'antd';
import PropTypes from 'prop-types';

const { Step } = Steps;

const ProposalRevisionSteps = ({ current }) => {
  return (
    <Steps current={current}>
      <Step title="Apply Proposal Revision" />
      <Step title="Confirm to Submit" />
      <Step title="Approval" />
      <Step title="Result" />
    </Steps>
  );
};

ProposalRevisionSteps.propTypes = {
  current: PropTypes.number.isRequired,
};

export default ProposalRevisionSteps;
